import Vue from 'vue'
export default ({ store }) => {
  // nuxtを外部から叩くため
  //https://tekitoumemo.hatenablog.com/entry/2020/03/14/163810
  window.storeCtl = store
  // Vueインスタンスとして使いたければ
  // Vue.prototype.$hoge = Hoge
  // Vue.prototype.$hoge.$store = store
}
